// Auth configuration sourced from environment variables (set during build via pipeline)
const AUTH_CONFIG = {
	clientId: import.meta.env.VITE_AUTH_CLIENT_ID || "",
	authority: import.meta.env.VITE_AUTH_AUTHORITY || "",
	scope: import.meta.env.VITE_AUTH_SCOPE || "",
};

export default AUTH_CONFIG;
